export default __webpack_public_path__ + "img/btgICCdf.d49d70d7.svg";